import * as types from './actionTypes';
import axios from 'axios';
import { getHeader, getToken } from '../helper';

function getLocationsRequest() {
    return {
        type: types.LOAD_LOCATIONS_REQUEST
    }
}

function getLocationsReceive(data) {
    return {
        type: types.LOAD_LOCATIONS_SUCCESS,
        payload: data
    }
}

function getLocationsError(messages) {
    return {
        type: types.LOAD_LOCATIONS_FAILURE,
        payload: messages
    }
}

export function getLocations(params) {
    let URL = `${window.siteUrl}/api/v1/address/`;

    if(params && params.uri) URL = params.uri;

    return function (dispatch) {
        dispatch(getLocationsRequest())

        return axios.get(URL, {
            headers: getHeader()
        })
        .then(function (response) {
            dispatch(getLocationsReceive(response.data));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                dispatch(getLocationsError(err.data));
            }
        });
    }
}


function addLocationRequest() {
    return {
        type: types.ADD_LOCATION_REQUEST
    }
}

function addLocationReceive(data) {
    return {
        type: types.ADD_LOCATION_SUCCESS,
        payload: data
    }
}

function addLocationError(messages) {
    return {
        type: types.ADD_LOCATION_FAILURE,
        payload: messages
    }
}

export function addLocation(params, afterSuccess, afterError) {
    
    return function (dispatch) {
        dispatch(addLocationRequest())

        return axios.post(
            `${window.siteUrl}/api/v1/address/`,
            params,
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            if(afterSuccess) afterSuccess();
            dispatch(addLocationReceive(response.data));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                if(afterError) afterError(err.data);
                console.error("addLocationError", err.status, err.data, err.headers);
                dispatch(addLocationError(err.data));
            }
        });
    }
}


function updateLocationRequest() {
    return {
        type: types.UPDATE_LOCATION_REQUEST
    }
}

function updateLocationReceive(data) {
    return {
        type: types.UPDATE_LOCATION_SUCCESS,
        payload: data
    }
}

function updateLocationError(messages) {
    return {
        type: types.UPDATE_LOCATION_FAILURE,
        payload: messages
    }
}

export function updateLocation(location, afterSuccess, afterError) {
    
    return function (dispatch) {
        dispatch(updateLocationRequest());

        let {title, comment, address, latitude, longitude, radius} = location;

        return axios.patch(
            `${window.siteUrl}/api/v1/address/${location.id}/`,
            {
                title,
                comment,
                address,
                latitude,
                longitude,
                radius
            },
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            if(afterSuccess) afterSuccess();
            dispatch(updateLocationReceive(location));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                if(afterError) afterError(err.data);
                console.error("updateLocationError", err.status, err.data, err.headers);
                dispatch(updateLocationError(err.data));
            }
        });
    }
}


function deleteLocationRequest() {
    return {
        type: types.DELETE_LOCATION_REQUEST
    }
}

function deleteLocationReceive(data) {
    return {
        type: types.DELETE_LOCATION_SUCCESS,
        payload: data
    }
}

function deleteLocationError(messages) {
    return {
        type: types.DELETE_LOCATION_FAILURE,
        payload: messages
    }
}

export function deleteLocation(location, afterSuccess, afterError) {
    
    return function (dispatch) {
        dispatch(deleteLocationRequest());

        let {title, comment, address, latitude, longitude, radius} = location;

        return axios.delete(
            `${window.siteUrl}/api/v1/address/${location.id}/`,
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            if(afterSuccess) afterSuccess();
            dispatch(deleteLocationReceive(location));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                if(afterError) afterError(err.data);
                console.error("deleteLocationError", err.status, err.data, err.headers);
                dispatch(deleteLocationError(err.data));
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/locationActions.js